import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Sparkles, Menu, X, Facebook, Instagram, Phone, Mail, MessageCircle } from 'lucide-react';
import { MovaAstroLogo } from './MovaAstroLogo';

const Navigation = () => {
  const { user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      {/* Top Contact Bar */}
      <div className="bg-gradient-to-r from-orange-100 to-amber-100 border-b-2 border-orange-200">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-10 text-sm">
            <div className="flex items-center gap-4 text-gray-700">
              <a href="tel:+919259806072" className="flex items-center gap-2 hover:text-orange-600 transition-colors">
                <Phone className="w-4 h-4" />
                <span className="hidden sm:inline">+91 92598 06072</span>
              </a>
              <a href="mailto:movaastroconsult@gmail.com" className="flex items-center gap-2 hover:text-orange-600 transition-colors">
                <Mail className="w-4 h-4" />
                <span className="hidden sm:inline">movaastroconsult@gmail.com</span>
              </a>
            </div>
            
            <div className="flex items-center gap-3">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-1.5 hover:bg-orange-200 rounded-full transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4 text-orange-600 hover:text-orange-700" />
              </a>
              <a 
                href="https://wa.me/919259806072" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-1.5 hover:bg-orange-200 rounded-full transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-4 h-4 text-orange-600 hover:text-orange-700" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-1.5 hover:bg-orange-200 rounded-full transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4 text-orange-600 hover:text-orange-700" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation Bar */}
      <div className="bg-white border-b-2 border-orange-200">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/">
              <MovaAstroLogo />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-gray-700 hover:text-orange-600 transition-colors">
                Home
              </Link>
              <Link to={{ pathname: "/", hash: "#services" }} className="text-gray-700 hover:text-orange-600 transition-colors">
                Services
              </Link>
              <Link to="/faq" className="text-gray-700 hover:text-orange-600 transition-colors">
                FAQ
              </Link>
              <Link to="/blog" className="text-gray-700 hover:text-orange-600 transition-colors">
                Blog
              </Link>
              <Link to="/booking" className="text-gray-700 hover:text-orange-600 transition-colors">
                Reserve a Spot
              </Link>
              {user ? (
                <>
                  <Link to="/dashboard" className="text-gray-700 hover:text-orange-600 transition-colors">Dashboard</Link>
                  <button onClick={logout} className="text-gray-700 hover:text-orange-600 transition-colors">Logout</button>
                </>
              ) : (
                <Link to="/login" className="text-gray-700 hover:text-orange-600 transition-colors">Sign In</Link>
              )}
              <Link to="/mini-chart" className="px-6 py-2 bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white rounded-full transition-all shadow-lg">
                Get Mini Chart
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-orange-600 hover:text-orange-700 transition-colors"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t-2 border-orange-200">
              <div className="flex flex-col gap-4">
                <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-gray-700 hover:text-orange-600 transition-colors py-2">
                  Home
                </Link>
                <Link to={{ pathname: "/", hash: "#services" }} className="text-gray-700 hover:text-orange-600 transition-colors py-2">
                  Services
                </Link>
                <Link to="/faq" className="text-gray-700 hover:text-orange-600 transition-colors py-2">
                  FAQ
                </Link>
                <Link to="/blog" className="text-gray-700 hover:text-orange-600 transition-colors py-2">
                  Blog
                </Link>
                <Link to="/booking" className="text-gray-700 hover:text-orange-600 transition-colors py-2">
                  Reserve a Spot
                </Link>
                {user ? (
                  <>
                    <Link to="/dashboard" className="text-gray-700 hover:text-orange-600 transition-colors py-2">Dashboard</Link>
                    <button onClick={logout} className="text-gray-700 hover:text-orange-600 transition-colors py-2 text-left">Logout</button>
                  </>
                ) : (
                  <Link to="/login" className="text-gray-700 hover:text-orange-600 transition-colors py-2">Sign In</Link>
                )}
                <Link to="/mini-chart" className="px-6 py-2 bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white rounded-full transition-all w-full shadow-lg text-center">
                  Get Mini Chart
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;